export default __webpack_public_path__ + "media/images/default-img-25240097.svg";